<template>
  <div>
    <div class="principal principal--cliente-and-comerciante">
      <div class="contenedor-login contenedor-login--cliente-and-comerciante">
        <div class="div-home">
          <a href="https://sumabeneficios.com/">
            <button type="button" class="btn btn-link">
              <!-- <blaise-icon icon="ATRAS" /> -->
              <img id="cb-logo" src="img/ico-flecha-izq.svg" />
              <span>INICIO</span>
            </button>
          </a>
        </div>
        <div class="logo">
          <img id="cb-logo" src="img/logo-ingreso-cb.svg" />
        </div>
        <login-cliente :logInWithDniFunction="clienteLogInWithDni" />
        <div class="ingreso-comercios">
          <button @click="clickShowComercianteLogIn()">
            <img id="cb-logo" src="img/btn-ingreso-comercio.svg" />
          </button>
        </div>
      </div>
      <modal-login-comerciante
        ref="modalLoginComerciante"
        :logInWithEmailAndPasswordFunction="comercianteLogInWithEmailAndPassword"
      /></div>
      <Footer />
    </div>
</template>

<script>
import "./login-cliente-and-comerciante.scss";
import LoginCliente from "./LoginCliente.vue";
import ModalLoginComerciante from "./ModalLoginComerciante.vue";
import Footer from '../../../components/cliente/visita/Footer.vue';
import { AuthFacade as AuthClienteFacade } from "../../../service/cliente/afiliado/auth/auth.facade";
import { AuthFacade as AuthComercianteFacade } from "../../../service/comerciante/auth/auth.facade";
import { RouteNames as ClienteRouteNames } from "../../../routes/cliente.routes";
import { RouteNames as ComercianteRouteNames } from "../../../routes/comerciante.routes";

export default {
  components: {
    LoginCliente,
    ModalLoginComerciante,
    Footer
  },
  data() {
    return {
      model: {
        cliente: {
          volverAPaginaAnterior: false,
        },
      },
    };
  },
  created() {
    if (this.$route.params.volver != undefined) {
      this.model.cliente.volverAPaginaAnterior = this.$route.params.volver;
    }

    if (this.$route.params) {
      const dni = this.$route.params.dni;
      if (dni) {
        console.log("DNI detectado, ingresando...");
        this.clienteLogInWithDni(dni);
      }
    }
  },
  methods: {
    clickGoBack() {
      if (this.model.cliente.volverAPaginaAnterior) {
        this.goToPreviousPage();
      } else {
        this.goToClientHomeView();
      }
    },
    clickShowComercianteLogIn() {
      this.$refs.modalLoginComerciante.show();
    },
    async clienteLogInWithDni(dni) {
      await AuthClienteFacade.loginWithDni(dni);
      this.goToClientLoggedView();
    },
    async comercianteLogInWithEmailAndPassword(email, password) {
      await AuthComercianteFacade.logIn(email, password);
      this.goToComercianteHome();
    },
    goToClientHomeView() {      
      this.$router.push({ name: ClienteRouteNames.home });
    },
    goToClientLoggedView() {
      if (this.model.cliente.volverAPaginaAnterior) {
        this.goToPreviousPage();
      } else {        
        this.goToClientHomeView();
      }
    },
    goToComercianteHome() {
      this.$router.push({
        name: ComercianteRouteNames.Ventas,
      });
    },
    goToPreviousPage() {
      this.$router.go(-1);
    },
  },
  mounted(){
    if(localStorage.getItem("dni") && localStorage.getItem("iduser") && localStorage.getItem("user")){
      this.$router.push("/home");
    }
  }
};
</script>

<style>
.contenedor-login .logo {
  /* bottom: 10%; */
  position: relative;
}

.contenedor-login .logo img {
  width: 77%;
}

.div-home {
  align-self: flex-start;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.div-home button {
  color: var(--color-estructura-c);
  text-decoration: none;
}

.div-home button span {
  font-family: "din-medium";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  text-align: left;
}

.div-home button img {
  margin-right: 5px;
  bottom: 1px;
  position: relative;
}

.div-home button:hover,
.div-home svg:hover {
  font-size: 13px;
  color: var(--color-estructura-c);
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.div-home svg {
  margin-right: 10px;
}

.btn-link {
  color: black;
  text-decoration: none;
}

.ingreso-comercios button {
  background: transparent;
}

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .principal {
    overflow: auto;
  }
  .contenedor-login {
    width: 80%;
    height: 80%;
    min-height: 530px;
    border-radius: 10px;
    grid-template-rows: 10% 40% 25% 25%;
    margin: 10px 0px;
  }

  .contenedor-login .logo img {
    width: 50%;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .contenedor-login {
    width: 630px;
    height: 80%;
  }

  .contenedor-login .logo img {
    width: 362px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .contenedor-login {
    grid-template-rows: 15% 35% 25% 25%;
    width: 630px;
  }

  .contenedor-login .logo img {
    width: 371px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .contenedor-login {
    height: 541px;
    grid-template-rows: 10% 40% 25% 25%;
  }

  .div-home {
    align-items: flex-end;
  }

  .div-home button {
    top: 10px;
    margin-left: 10px;
  }

  .contenedor-login .logo img {
    bottom: 20px;
    position: relative;
    width: 438px;
  }
}
</style>
